import { InjectionKey } from "vue";
import { getCurrentHostname } from "@/core/helpers/hostname";

export const GlobalMethodsKey: InjectionKey<GlobalMethods> =
  Symbol("GlobalMethods");

export interface GlobalMethods {
  host: string;
  getHost: () => string;
}

export function useGlobalMethods(): GlobalMethods {
  const host = "sav.meuble-promo.fr";

  function getHost() {
    return getCurrentHostname();
  }

  return {
    host,
    getHost,
  };
}
